import { Component, Input, inject,
    ChangeDetectionStrategy
} from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from '@openng/optimus-ui/dynamicdialog';
import { ButtonDefinition } from '../../models/button-definition.model';

@Component({
    selector: 'sm-message-dialog',
    templateUrl: './message-dialog.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageDialogComponent {

    ref = inject(DynamicDialogRef);
    config = inject(DynamicDialogConfig);

    @Input()
    message = "";
    @Input()
    details = "";
    @Input()
    detailsLabel = "Details";
    @Input()
    detailsInline = false;
    @Input()
    buttons: ButtonDefinition[] = [];
    @Input()
    icon = "";

    constructor() {
        this.message = this.config.data.message || "";
        this.details = this.config.data.details ?? "";
        this.detailsLabel = this.config.data.detailsLabel ?? "Details";
        this.detailsInline = this.config.data.detailsInline ?? false;
        this.buttons = this.config.data.buttons || [];
    }

    click(id: string): void {
        this.ref.close(id);
    }

}
